/**
 * General form-related constants shared across all feature forms.
 */

/**
 * Matches two or more consecutive whitespace characters (spaces).
 * Use with String.replace() to collapse multiple spaces into a single space.
 */
export const MULTIPLE_SPACES_REGEX = / {2,}/g;
